import { useEffect, useState } from 'react';

/**
 * @desc Whole seconds since `startedAt`, re-read once a second.
 *
 * The count is taken from the turn rather than from the caller's mount so a reload part-way
 * through shows what the user has actually waited, not a clock restarted by a remount. Falls
 * back to the mount when the stamp is missing or unparseable — the optimistic group minted
 * before the server's first event lands, and conversations recorded before turn timing existed.
 */
export function useElapsedSeconds(startedAt?: string): number {
  const [mountedAt] = useState(() => Date.now());
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const parsed = startedAt ? new Date(startedAt).getTime() : Number.NaN;
  const start = Number.isFinite(parsed) ? parsed : mountedAt;

  return Math.max(0, Math.floor((now - start) / 1000));
}
